import React from "react";

const styles = {
  container: {
    width: "100%",
    // padding: '0em .5em',
    flex: "1 1 auto",
    flexDirection: "column",
    display: "flex",
    overflow: "auto"
  }
};

function CustomContainer(props) {
  return (
    <div
      style={styles.container}
      {...props}
    >
      {props.children}
    </div>
  );
}

export default CustomContainer;